(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-free-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-free-gifts')) {
    customElements.define('product-free-gifts', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.syncQuantity = () => {
          const form = document.getElementById(this.dataset.formId);
          const quantity = this.getQuantity(form);
          this.querySelectorAll('[data-gift-quantity]').forEach((label) => {
            label.textContent = `× ${quantity}`;
          });
        };
        const onQuantityChange = (event) => {
          if (event.target.name === 'quantity' && event.target.form === document.getElementById(this.dataset.formId)) {
            this.syncQuantity();
          }
        };
        document.addEventListener('input', onQuantityChange, options);
        document.addEventListener('change', onQuantityChange, options);
        this.addEventListener('change', (event) => {
          if (event.target.matches('.product-free-gifts__variant-input')) {
            if (event.target.disabled) return;
            const option = event.target.closest('.product-free-gifts__option');
            this.updateVariant(option, event.target);
            option.querySelector('.product-free-gifts__radio').checked = true;
          }
          this.showError('');
        }, options);
        this.querySelectorAll('.product-free-gifts__variant-input:checked').forEach((input) => {
          this.updateVariant(input.closest('.product-free-gifts__option'), input);
        });
        this.syncQuantity();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      getQuantity(form) {
        return Math.max(1, parseInt(form?.elements.namedItem('quantity')?.value, 10) || 1);
      }

      updateVariant(option, input) {
        option.querySelector('.product-free-gifts__radio').value = input.value;
        option.querySelector('.product-free-gifts__variant').textContent = input.dataset.title;
        option.querySelector('[data-gift-price]').innerHTML = input.dataset.price;
        const badge = option.querySelector('[data-gift-badge]');
        if (badge) {
          badge.textContent = input.dataset.badge;
          badge.hidden = !input.dataset.badge;
        }
        const originalPrice = option.querySelector('[data-gift-original-price]');
        originalPrice.innerHTML = input.dataset.originalPrice;
        originalPrice.hidden = input.dataset.showOriginal !== 'true';
        const image = option.querySelector('.product-free-gifts__image');
        if (image && input.dataset.image) {
          image.src = input.dataset.image;
          image.removeAttribute('srcset');
        }
      }

      getCartItems() {
        const form = document.getElementById(this.dataset.formId);
        const mainInput = form?.querySelector('.main-product-variant-input');
        const selectedGift = this.querySelector('.product-free-gifts__radio:checked');
        if (!mainInput?.value || !selectedGift?.value || selectedGift.disabled) throw new Error(this.dataset.errorMessage);
        const quantity = this.getQuantity(form);
        const formData = new FormData(form);
        const mainItem = { id: mainInput.value, quantity };
        const properties = {};
        for (const [name, value] of formData.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) mainItem.properties = properties;
        if (formData.get('selling_plan')) mainItem.selling_plan = formData.get('selling_plan');
        const items = [mainItem];
        form.querySelectorAll('input[type="hidden"][name="id[]"]').forEach((input) => {
          if (input !== mainInput && !input.disabled && input.value) items.push({ id: input.value, quantity: 1 });
        });
        items.push({ id: selectedGift.value, quantity });
        this.showError('');
        this.syncQuantity();
        return items;
      }

      showError(message) {
        const error = this.querySelector('.product-free-gifts__error');
        error.textContent = message;
        error.hidden = !message;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
